import { api } from ".";

export const getMDAList = async ({ tenantCategory }) => {
  return await api.get(`/sso/integration/merchantsForSelfService?tenantCategory=${tenantCategory}`);
};
export const getMDAForms = async ({ token, accessToken, tenantId = null,  }) => {
  api.setHeaders({
    Authorization: `Bearer ${token}`,
    "Tenant-ID": tenantId,
    "X-SSO-ACCESS-TOKEN": accessToken,
  });
  return await api.get("/wfm/form/mda-forms");
};